/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_Loading_CommitInputs */



/**
* | output |
* | --- |
* | "Loading new commit..." |
*
* @param {Team_Sync_Status_Loading_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_loading_commit = /** @type {((inputs?: Team_Sync_Status_Loading_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_Loading_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du nouveau commit...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Commit wird geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento nuovo commit...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка нового коммита...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando nuevo commit...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载新的提交...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいコミットを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया कमिट लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando novo commit...")
	return /** @type {LocalizedString} */ ("Loading new commit...")
});